import {BaseDTO} from "./_baseDTO.interface";
import {BaseIntDTO} from "./_baseIntDTO.interface";

export interface BodyTypeDTO extends BaseIntDTO {
  bodyTypeName: string;
}
